var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-open-model"},[_c('div',{staticClass:"model-inner"},[_vm._v(" 尊敬的旅客，产品暂未开放"),_c('br'),_vm._v("感谢您的关注，敬请期待! ")])])
}]

export { render, staticRenderFns }